import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';

/**
 * Create a wrapper composition to support DIalog functionality
 * @param ComposedComponent
 * @returns {{Component}}
 */

export function withDialog(ComposedComponent) {
    return @observer class extends Component {
        @observable showDialog = false;
        @observable dialogs = {};

        @action setDialog = (name) => {
            this.dialogs = {...this.dialogs, [name]: false};
        };

        @action closeDialog = (name) => {
            this.dialogs[name] = false;
            if (!name) this.showDialog = false;
        };

        @action openDialog = (event, name) => {
            if (event) event.stopPropagation();
            this.dialogs[name] = true;
            if (!name) this.showDialog = true;
        };

        isOpen = (name) => {
            if (!(name in this.dialogs)) {
                console.error(`Dialog not set "${name}"! Call setDialog actions`);
            }
            return this.dialogs[name] || false;
        };

        render() {
            return <ComposedComponent {...this.props} showDialog={this.showDialog} openDialog={this.openDialog}
                closeDialog={this.closeDialog} dialogs={this.dialogs} setDialog={this.setDialog} isOpen={this.isOpen}/>;
        }
    };
}
